import type { SelectProps } from "@heroui/react";
import {
	BOARDS_KEY_MAPPER_ENUM,
	SERVICES_COLUMNS,
} from "@onesolution/constants";
import { type AppFormApi, useLanguage, useUserInfos } from "@onesolution/hooks";
import { getItemPageByValuesFromServer } from "@onesolution/serverFn";
import { useEffect } from "react";

export default function ServicesSelector(
	props: {
		name: string;
		form: AppFormApi;
		label?: string;
		useUserDefault?: boolean;
		skipAdminCheck?: boolean;
	} & Omit<SelectProps, "children" | "form">,
) {
	const { t } = useLanguage();
	const { form, name, useUserDefault = false, ...restProps } = props;

	const services = getItemPageByValuesFromServer.useQuery({
		boardId: BOARDS_KEY_MAPPER_ENUM.services,
		columnIds: [SERVICES_COLUMNS.name],
		skipAdminCheck: props.skipAdminCheck,
		filter: [],
	});

	const user = useUserInfos();

	// biome-ignore lint/correctness/useExhaustiveDependencies: <trigger only once>
	useEffect(() => {
		if (useUserDefault) {
			form.setFieldValue(name, user.favoriteServices);
		}
	}, []);

	return (
		<form.AppField name={name}>
			{(field) => (
				<field.SelectMultiple
					label={props.label || t("name.services")}
					placeholder={t("name.services")}
					items={services.data}
					isLoading={services.isLoading}
					{...restProps}
				/>
			)}
		</form.AppField>
	);
}
